// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"account":"6f1258ee","administration":"3e19fe3b"}[chunkId] + ".chunk.js";
};